/* eslint-disable comma-dangle */
/* eslint-disable quotes */

import { LlmMockThread } from '@websolutespa/bom-mixer-llm';

export const thread: LlmMockThread = [
  {
    "role": "user",
    "chunks": [
      "markdown\n",
    ]
  },
  {
    "role": "assistant",
    "chunks": [
      "Markdown\n",
      "  \n",
      "Header 1  \n========  \n",
      "  \n",
      "Header 2  \n--------  \n",
      "  \n",
      "### Header 3 ###  \n",
      "#### Header 4 ####  \n",
      "##### Header 5 #####  \n",
      "###### Header 6 ######   \n",
      "  \n",
      "### Phrase Emphasis   \n",
      "  \n",
      "*italic*   \n",
      "**bold**  \n",
      "_italic_   \n",
      "__bold__  \n",
      "  \n",
      "### Links  \n",
      "  \n",
      "An [example](https://www.gmail.com/ \"Title\")  \n",
      "  \n",
      "### Images  \n",
      "![alt text](https://picsum.photos/id/104/800/600 \"Title\")  \n",
      "  \n",
      "### Lists  \n",
      "  \n",
      "1.  Foo  \n",
      "2.  Bar  \n",
      "  \n",
      "*   A list item.  \n",
      "    With multiple paragraphs.  \n",
      "*   Bar  \n",
      "*   Abacus  \n",
      "    * answer  \n",
      "*   Bubbles  \n",
      "    1.  bunk  \n",
      "    2.  bupkis  \n",
      "        * BELITTLER  \n",
      "    3. burper  \n",
      "*   Cunning  \n",
      "  \n",
      "### Blockquotes  \n",
      "> Email-style angle brackets  \n",
      "> are used for blockquotes.  \n",
      "  \n",
      "> > And, they can be nested.  \n",
      "  \n",
      "> ### Headers in blockquotes  \n",
      ">   \n",
      "> * You can quote a list.  \n",
      "> * Etc.  \n",
      "  \n",
      "### Code Spans  \n",
      "`<code>` spans are delimited by backticks.  \n",
      "  \n",
      "You can include literal backticks like `` `this` ``.  \n",
      "  \n",
      "### Preformatted Code Blocks  \n",
      "  \n",
      "This is a normal paragraph.  \n",
      "  \n",
      "    This is a preformatted  \n",
      "    code block.  \n",
      "  \n",
      "```  \n",
      "function sum(a, b) {  \n",
      "  return a + b;  \n",
      "}  \n",
      "```  \n",
      "  \n",
      "### Horizontal Rules  \n",
      "  \n",
      "---  \n",
      "  \n",
      "* * *  \n",
      "  \n",
      "- - - -   \n",
      "  \n",
      "### Manual Line Breaks  \n",
      "  \n",
      "Roses are red,   \n",
      "Violets are blue.  \n",
      "  \n"
    ]
  },
  {
    "role": "user",
    "chunks": [
      "who is Giovanni Allasia?\n",
    ]
  },
  {
    "role": "assistant",
    "chunks": [
      {
        "type": "info",
        "threadId": "40568a23-f467-44d0-bfd1-deb5f8892525"
      },
      "Giovanni Allasia is the VP, Enterprise Solutions & Services in the Technology function, specifically in the Technology Management Department, based in Italy. He started in 2024. His email is g.allasia@efg.gg.\n\n",
      { "type": "end" }
    ]
  },
  {
    "role": "user",
    "chunks": [
      "who is juran papuga?\n",
    ]
  },
  {
    "role": "assistant",
    "chunks": [
      "Ecco alcuni elementi custom:\n",
      {
        "type": "customCard",
        "id": "xxxxxx-1",
        "title": "A custom card",
        "media": {
          "type": "image",
          "src": "https://picsum.photos/id/11/640/480"
        },
        "href": "/"
      },
      "Posso aiutarti in altro modo?\n"
    ]
  }
];
